// @flow

import { sortBy } from 'lodash';

import {
  APP_STATUSES,
  APP_STATUS_INVITE_ONLY,
  DEPLOYMENT_STATUSES,
  VERSION_STATUSES,
} from 'app/developer-v3/constants';

import type { AppStatusName, AppType } from 'app/developer-v3/types';

const allStatuses = {
  private: APP_STATUSES.private,
  pending: APP_STATUSES.pending,
  beta: APP_STATUSES.beta,
  inviteOnly: APP_STATUS_INVITE_ONLY,
  public: APP_STATUSES.public,
};

const legacyAppStatusNames = [
  allStatuses.private,
  allStatuses.pending,
  allStatuses.inviteOnly,
  allStatuses.public,
].map(s => s.name);

const allStatusNames = Object.keys(allStatuses);

const sortAppsByStatus = (apps: Array<AppType>, isDesc?: boolean = true) => {
  const order = isDesc ? [...allStatusNames].reverse() : allStatusNames;
  return sortBy(apps, app => order.indexOf(app.status.name));
};

const getStatus = (status: $Keys<typeof allStatuses>) => {
  return allStatuses[status];
};

const normalizeStatusName = (status?: number | AppStatusName) => {
  const name =
    typeof status === 'number' ? legacyAppStatusNames[status] : status;

  return name || APP_STATUSES.private.name;
};

const getVersionStatus = (deployment: string, deprecationDate?: string) => {
  return deprecationDate && Date.parse(deprecationDate) < Date.now()
    ? VERSION_STATUSES.deprecated
    : deployment === DEPLOYMENT_STATUSES.production
    ? VERSION_STATUSES.public
    : VERSION_STATUSES.private;
};

export { getStatus, getVersionStatus, normalizeStatusName, sortAppsByStatus };
